<script>
import Validation from '@/plugins/validation'
import { Input, AutocompleteSelect } from '@/components/formelements'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'SiteGroupSearch',
  data() {
    return {
      ...Validation,
      dialog: false,
      tableLoading: false,
      searched: false,
      newSiteGroup: false
    }
  },
  components: {
    Input,
    AutocompleteSelect,
    // Checkbox,
  },
  async mounted() {
    await this.$store.dispatch('siteGroup/GET_SITE_TYPES')
  },  
  computed: {
    ...mapState({
      statusTypes: state => state.search.statusTypes,
      siteSearchResults: state => state.siteGroup.siteSearchResults,
      siteTypes: state => state.siteFilter.siteTypes,
    }),
    ...mapGetters({
      siteGroupTypes: 'siteGroup/siteGroupTypes',
      attachedSiteGroups: 'siteGroup/attachedSiteGroups',
      siteTypeItems: 'siteFilter/siteTypeItems'
    }),
    includeRetailers(){
      return [
        () => {
          return !(this.retailerWithNoPretailer && (this.siteSearchID == '' && this.siteCode == '')) || 'Site ID or Site Code must be entered in order to include retailers w/o Pretailers'
        },
      ]
    },
  },
  methods: {
    headers(){
      return [
        {
          text: 'Site Group ID',
          sortable: false,
          value: 'ID'
        },
        {
          text: 'Site Group Name',
          sortable: false,
          value: 'Name'
        },
        {
          text: 'Site Group Type',
          sortable: false,
          value: 'TypeID'
        }
      ]
    },
    siteHeaders() {
      return [
        {
          text: 'Attached',
          value: 'IsAttachedToSite'
        },
        {
          text: 'Site ID',
          value: 'ID'
        },
        {
          text: 'Site Code',
          value: 'Code'
        },
        {
          text: 'Site Type Name',
          value: 'TypeID'
        }
      ]
    },
    newSiteGroupClicked() {
      this.newSiteGroup = true,
      this.$store.dispatch('siteGroup/RESET')
      this.dialog = true
    },
    async save(){
      if(this.$refs.newSiteForm.validate()) {
        await this.$store.dispatch('ui/SHOW_CONFIRM_DIALOG', {
          header: 'Are you sure?',
          message: `Do you want to create new Site Code <span class="font-weight-black">${ this.createSiteCode }</span>?`,
          action: 'siteFilter/INSERT_SITE',
          data: null,
          nextTickAction: '',
          nextTickData: {},
        })
      }
    },
    typeID(id){
      const type = this.siteGroupTypes.filter( type => type.value == id)
      return type[0].text
    },
    siteTypeID(id){
      const type = this.siteTypes.filter( type => type.ID == id)
      return type[0].Name
    },
    getRowStatus: function(statusCode) {
      const status = this.statusTypes.filter( type => type.ID == statusCode)
      return status[0].Name
    },
    async searchSite() {
      if(this.$refs.searchForm.validate()) {
        this.tableLoading = true
        await this.$store.dispatch('siteGroup/FIND_SITE_GROUP', { itemsPerPage: 10, page: 1 })
        this.tableLoading = false
        this.searched = true
      }
    },
    async saveUpdateSiteGroup(){
      if (this.$refs.updatedSiteGroup.validate()){
        if (this.newSiteGroup){
          await this.$store.dispatch('siteGroup/INSERT_SITE_GROUP')
          if (this.$store.state.siteGroup.ID != '') this.newSiteGroup = false
          await this.$store.dispatch('siteGroup/FIND_SITE_GROUP', { itemsPerPage: 10, page: 1 })
        } else {
          await this.$store.dispatch('siteGroup/UPDATE_SITE_GROUP')
          await this.$store.dispatch('siteGroup/FIND_SITE_GROUP', { itemsPerPage: 10, page: 1 })
        }
      }
    },
    async pagination(e) {
      if(!this.searched) return
      this.tableLoading = true
      let index = ( e.page * e.itemsPerPage ) - e.itemsPerPage + 1
      await this.$store.dispatch('siteGroup/FIND_SITE_GROUP', { itemsPerPage: e.itemsPerPage, page: index })
      this.tableLoading = false
    },
    async rowClicked( e, {item} ){
      this.newSiteGroup = false
      this.dialog = true
      await this.$store.dispatch('siteGroup/GET_SITE_GROUP', item.ID )
      await this.$store.dispatch('siteGroup/FIND_SITE_GROUP_ATTACHMENT')
    },
    async updatedSiteAttachment(item){
      const status = function(){
        if (item.IsAttachedToSite == false) return 1
        return 901
      }
      await this.$store.dispatch('siteGroup/ATTACH_DETACH_SITE_GROUP', { siteID: item.ID, rowStatus: status() })
      await this.$store.dispatch('siteGroup/FIND_SITE_GROUP_ATTACHMENT')
    }
  }
}
</script>

<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" sm="8">
        <Input form="siteGroup" field="siteGroupSearch" placeholder="" label="Site Code 'Like'" />
      </v-col>
    </v-row>
    <v-form ref="searchForm">
      <v-row justify="center">
        <v-col class="d-flex mb-6" cols="12" sm="2" >
          <v-btn @click="searchSite" width="125px" depressed color="accent">
            Search<v-icon right>mdi-magnify</v-icon>
          </v-btn>
        </v-col>
        <v-col class="d-flex mb-6" cols="12" sm="2" >
          <v-btn @click="newSiteGroupClicked" depressed color="accent">
            <v-icon left>mdi-plus-box</v-icon>Create New Site Group
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-row >
      <v-col cols="12">
        <p class="d-flex justify-center primary--text">Double click Row to view/edit Site Group</p>
        <v-data-table
          :server-items-length="$store.state.siteGroup.totalOnServer"
          :headers="headers()"
          :items="siteSearchResults"
          :items-per-page="10"
          @update:options="pagination"
          @dblclick:row="rowClicked"
          :loading="tableLoading"
          :footer-props="{ 'items-per-page-options': [ 10, 25 , 50], 'show-first-last-page': true } " 
        >
          <template v-slot:item.TypeID=" { item }" >
            <span>
              {{ typeID(item.TypeID) }}
            </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog persistent v-model="dialog" width="800">
      <v-card>
        <v-card-title class="primary--text">
          Site Group Attribute
        </v-card-title>
        <v-form ref="updatedSiteGroup">
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6">
                Site Group ID: {{$store.state.siteGroup.ID}}
              </v-col>
              <v-col cols="12" sm="6">
                Row Status Type: {{ getRowStatus($store.state.siteGroup.RowStatus) }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <Input form="siteGroup" field="Name" :rules="[...required]" placeholder="" label="Site Group Name" />
              </v-col>
              <v-col cols="12" sm="6">
                <AutocompleteSelect form="siteGroup" field="TypeID" :rules="[...required]" :items="siteGroupTypes" placeholder="" label="Site Type" /> 
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                Last updated By <br/> {{ $store.state.siteGroup.LastUpdatedBy }}
              </v-col>
              <v-col cols="12" sm="6">
                Last Updated Date <br/> {{ $store.state.siteGroup.LastUpdateDate }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
        <v-card-actions class="d-flex justify-end px-5 pb-5">
          <v-btn @click="dialog = false" width="125" color="secondary">
            Close
          </v-btn>
          <v-btn @click="saveUpdateSiteGroup" width="125" color="primary">
            <v-icon left>mdi-content-save</v-icon>Save
          </v-btn>
        </v-card-actions>
        <v-card-text v-if="!newSiteGroup">
          <v-data-table
            :headers="siteHeaders()"
            :items="attachedSiteGroups"
            multi-sort
            sort-by="IsAttachedToSite"
            sort-desc
          >
            <template v-slot:item.IsAttachedToSite=" { item }" >
              <span>
                <v-simple-checkbox 
                  @click.capture="updatedSiteAttachment(item)"
                  color="primary"
                  :ripple="false"
                  :value="item.IsAttachedToSite"
                ></v-simple-checkbox>
              </span>
            </template>
            <template v-slot:item.TypeID=" { item }" >
              <span>
                {{ siteTypeID(item.TypeID) }}
              </span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
